export default __webpack_public_path__ + "static/media/day.09a6a853.jpg";